import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";

// Small link from a product page to its step-by-step guide in the Help Center (id must exist in GUIDES).
export default function GuideLink({ id, className = "" }) {
  return (
    <Link to={`/bantuan#panduan-${id}`} className={`inline-flex items-center gap-1 text-sm font-medium text-blue-700 hover:underline ${className}`} data-testid={`guide-link-${id}`}>
      <BookOpen className="h-4 w-4" aria-hidden="true" />Lihat panduan
    </Link>
  );
}
